import React from 'react';
import PropTypes from 'prop-types';

function OnlineStore({ size, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <path d="M5.13313 9.07745C5.16822 8.20021 5.88959 7.50712 6.76754 7.50712H17.2325C18.1104 7.50712 18.8318 8.20021 18.8669 9.07745L19.2554 18.7917C19.2926 19.72 18.5501 20.4928 17.621 20.4928H6.37897C5.44995 20.4928 4.70743 19.72 4.74456 18.7917L5.13313 9.07745Z" />
      <path d="M15.5 10L15.0444 4.93795C14.9384 3.75974 13.9509 2.85712 12.7679 2.85712H11.2321C10.0491 2.85712 9.06163 3.75974 8.95559 4.93794L8.5 10" />
    </svg>
  );
}

OnlineStore.propTypes = {
  stroke: PropTypes.string.isRequired,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default OnlineStore;
